import { upperFirst } from "lodash-es";
import {Service, service, inject} from "./di";
import {i18n} from "../i18n/I18n";
import {LocationService} from "./LocationService";
import {ExpiredCanonicalsService} from "./ExpiredCanonicalsService";
import {SeoDataService} from "./SeoDataService";

export type IExpiredMetada = {
	city: string;
	name: string;
	id: string;
	state: string;
};

@service
export class ExpiredMetadaService extends Service {
	@inject expiredCanonicalsService: ExpiredCanonicalsService;
	@inject locationService: LocationService;
	@inject seoDataService: SeoDataService;

	data: IExpiredMetada = null;

	async setFlyerData(flyerId: string) {
		const merchantNames = this.expiredCanonicalsService.getMerchantNamesFromUrl();
		const flyers = await this.expiredCanonicalsService.findMerchant(merchantNames);
		const flyer = flyers.pop();
		const state = this.locationService.getStateName({
			slug: this.locationService.state
		});

		const data = {
			city: this.locationService.city,
			state,
			id: flyerId,
			name: flyer ? flyer.merchant : "",
		};

		this.data = data;
	}

	async setCouponData(slug: string, id: string) {
		this.setItemData(slug, id);
	}

	async setItemData(slug: string, id: string) {
		const name = slug
			.replace(`${id}-`, "")
			.split("-")
			.map(w => upperFirst(w))
			.join(" ");
		const state = this.locationService.getStateName({
			slug: this.locationService.state
		});

		const data = {
			city: this.locationService.city,
			state,
			id,
			name,
		};

		this.data = data;
	}

	getFlyerTitle() {
		return i18n("expired_flyer_title", this.data);
	}

	getFlyerH1() {
		return i18n("expired_flyer_h1", this.data);
	}

	getFlyerDescription() {
		return i18n("expired_flyer_description", this.data);
	}

	getFlyerBody() {
		return i18n("expired_flyer_body", this.data);
	}

	getCouponTitle() {
		return i18n("expired_coupon_title", this.data);
	}

	getCouponH1() {
		return i18n("expired_coupon_h1", this.data);
	}

	getCouponDescription() {
		return i18n("expired_coupon_description", this.data);
	}

	getCouponBody() {
		return i18n("expired_coupon_body", this.data);
	}

	getItemTitle() {
		return i18n("expired_item_title", this.data);
	}

	getItemH1() {
		return i18n("expired_item_h1", this.data);
	}

	getItemDescription() {
		return i18n("expired_item_description", this.data);
	}

	getItemBody() {
		return i18n("expired_item_body", this.data);
	}
}

